import React from "react";
import { Player } from "../../../types";
import "./Scoreboard.css";

interface ScoreboardProps {
  players: Player[];
  currentPlayerId?: string;
  hostId?: string;
  onRemovePlayer?: (playerId: string, playerName: string) => void;
  onViewCard?: (playerId: string, playerName: string) => void;
}

export const Scoreboard: React.FC<ScoreboardProps> = ({
  players,
  currentPlayerId,
  hostId,
  onRemovePlayer,
  onViewCard,
}) => {
  // Sort by bingo count (descending) then by name
  const sortedPlayers = [...players].sort((a, b) => {
    if (b.bingoCount !== a.bingoCount) {
      return b.bingoCount - a.bingoCount;
    }
    return a.name.localeCompare(b.name);
  });

  const isHost = currentPlayerId === hostId;

  const handleRemoveClick = (player: Player) => {
    if (!onRemovePlayer) return;
    onRemovePlayer(player.id, player.name);
  };

  return (
    <div className="scoreboard">
      <h3 className="scoreboard__title">Spieler</h3>
      <div className="scoreboard__list">
        {sortedPlayers.map((player) => (
          <div
            key={player.id}
            className={`scoreboard__player ${
              player.id === currentPlayerId ? "scoreboard__player--current" : ""
            }`}
          >
            <span className="scoreboard__player-name">
              <span
                className={`scoreboard__status-dot ${player.connected ? "scoreboard__status-dot--online" : "scoreboard__status-dot--offline"}`}
                title={player.connected ? "Verbunden" : "Nicht verbunden"}
              />
              {player.name}
              {player.id === hostId && (
                <span className="scoreboard__host-badge">👑</span>
              )}
            </span>
            <div className="scoreboard__player-actions">
              <span className="scoreboard__player-score">
                {player.bingoCount > 0 ? `${player.bingoCount}x` : "0x"}
              </span>
              {player.id !== currentPlayerId && onViewCard && (
                <button
                  className="scoreboard__view-btn"
                  onClick={() => onViewCard(player.id, player.name)}
                  title="Karte ansehen"
                >
                  👁️
                </button>
              )}
              {isHost && player.id !== currentPlayerId && onRemovePlayer && (
                <button
                  className="scoreboard__ban-btn"
                  onClick={() => handleRemoveClick(player)}
                  title="Spieler kicken/bannen"
                >
                  −
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
